import React from 'react';
import { styled } from '@linaria/react';
import PropTypes from 'prop-types';

import { isSubmitError } from '../../utils/validators';
import { Lock } from '../icon';

const LockContainer = styled.div`
  display: block;
  outline: none;
  background-color: transparent;
  border: none;
  padding: 0;
  margin: 0;
  position: absolute;
  left: 0;
  top: 50%;
  width: 43px;
  height: 43px;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
  border-radius: 0 var(--bb-field-border-radius) var(--bb-field-border-radius) 0;
  path {
    stroke: ${({ meta }) =>
      isSubmitError(meta) ? 'var(--bb-error-color)' : 'var(--bb-icon-color)'};
  }
`;

const LockComponent = props => (
  <LockContainer {...props}>
    <Lock />
  </LockContainer>
);

LockComponent.propTypes = {
  meta: PropTypes.object.isRequired,
};
export default LockComponent;
